import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// This line gets the HTML element where your app will be rendered.
// By default, it's a <div> with the id of 'root' inside public/index.html.
const root = ReactDOM.createRoot(document.getElementById('root'));

// This line renders the main App component inside the root element.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);